import {
  AustralianState,
  CampaignCompletionStateType,
  CampaignStage,
  NswContractStage,
  PropertyAddress,
  PropertyImageUrls,
  QldContractStage,
  UploadedDocument,
} from '@urbanx/agx-ui-components';
import {
  CampaignAdminModel,
  EnvelopeSubmissionModelStatus,
  EnvelopeSubmissionModelType,
  EnvelopeSubmissionRecipientStatus,
} from '@urbanx/agx.campaigns.client';
import { Dayjs } from 'dayjs';

export enum CampaignTableColumn {
  Campaign = 'address',
  Status = 'status',
  LeadAgent = 'leadAgentId',
  SecondAgent = 'secondAgentId',
  Marketing = 'marketing',
  Contract = 'contract',
  Launch = 'launch',
}

export enum CampaignTableColumnNames {
  Campaign = 'Campaign',
  Status = 'Status',
  LeadAgent = 'Lead Agent',
  SecondAgent = 'Second Agent',
  Marketing = 'Marketing',
  Contract = 'Contract',
  Launch = 'Launch',
  Action = '',
}

export enum CampaignColumnStatus {
  Agreement = 'Agreement',
  CurrentListing = 'Current Listing',
  UnderContract = 'Under Contract',
  Live = 'Live',
  Offline = 'Offline',
}

export enum CampaignsTab {
  All = 'All',
  Archived = 'Archived',
}

export interface CampaignCompletionState {
  completionType: CampaignCompletionStateType | null;
  completionUtc?: string;
}

export interface Campaign {
  id: string;
  address: PropertyAddress;
  createdByUserId: string;
  propertyImageUrls: PropertyImageUrls;
  leadAgentId: string;
  secondAgentId: string;
  stage: CampaignStage;
  blankContractIsLive: boolean;
  completionState: CampaignCompletionState;
  assignedAgentIds: string[];
  blankSalesContract: UploadedDocument | null;
  blankSalesContractFlattened: UploadedDocument | null;
  state: AustralianState;
}

export interface CampaignRequest {
  getAuthToken: () => Promise<string>;
  campaignId: string;
}

export interface Campaigns {
  data: Campaign[];
  pageIndex: number;
  pageSize: number;
  totalResults: number;
}

export interface CampaignOwnership {
  campaignId: string;
  leadAgentId: string;
  secondAgentId: string;
  assignedAgents: string[];
}
export interface FormDocumentSubmissionRecipient {
  recipientId: string;
  emailAddress: string;
  name: string;
  sentDateTime: Date | null;
  deliveredDateTime: Date | null;
  signedDateTime: Date | null;
  status: EnvelopeSubmissionRecipientStatus;
}

export interface FormDocumentSubmission {
  formDocumentSubmissionId: string;
  type: EnvelopeSubmissionModelType;
  status: EnvelopeSubmissionModelStatus;
  recipients: FormDocumentSubmissionRecipient[];
  createdAt: Date;
  updatedAt: Date | null;
}

export interface FormDocumentSubmissionDetails {
  agencyAgreementSubmission: FormDocumentSubmission | null;
}

export interface Contract {
  contractId: string;
  contractNames: string;
  stage?: QldContractStage | NswContractStage;
  salePrice?: number;
  initialDeposit?: number;
  balanceDeposit?: number;
}

export enum LaunchFilterOptions {
  Today = 'Today',
  ThisWeek = 'ThisWeek',
  NextWeek = 'NextWeek',
}

export interface SearchableCampaign extends CampaignAdminModel {
  fullAddressSearchable: string;
  cleanAddress: string[] | string;
  leadAgentName?: string;
  secondAgentName?: string;
  filterableLaunchDate?: Dayjs;
}
